module.exports = __webpack_public_path__ + "img/3.b1f1866e.png";